import * as React from 'react';
import styled from "styled-components";
import * as section from './components';
import * as pages from './pages';
import {useRoute} from "react-router5";
import {RouteName} from "router/routes";

const Wrapper = styled.div`
  width: 100%;
  background-color: #ffffff;
  min-height: calc(100vh + 1px);

  div {
    box-sizing: border-box;
  }
`;

const Container = styled.div`
  color: #29292B;
`;

/**
 * render landing page
 * @constructor
 */
export default function Landing(): React.ReactElement {
  const {route} = useRoute();
  const routeName: RouteName = route?.name;

  function renderContent() {
    switch (routeName) {
      case "landing":
        return <pages.Main />;
      case "landing.about":
        return <pages.About />;
      case "landing.blog":
        return <pages.Blog />;
      case "landing.faq":
        return <div>faq</div>;
      case "landing.feedback":
        return <pages.Feedback />;
    }
  }

  return (
    <Wrapper>
      <Container>
        <section.Header />
        {renderContent()}
      </Container>
    </Wrapper>
  );
}
